import ignoreNavigationOperation from './operation/ignoreNavigationOperation';
import reOpenAddinNavigationOperation from './operation/reOpenAddinNavigationOperation';
import sendErrorToAddinNavigationOperation from './operation/sendErrorToAddinNavigationOperation';
import sendItemUpdateToAddinNavigationOperation from './operation/sendItemUpdateToAddinNavigationOperation';
import terminateAddinNavigationOperation from './operation/terminateAddinNavigationOperation';
import { doesItemExist } from 'owa-addins-apis';
import { isExtensibilityContextInitialized, TaskPaneErrorType } from 'owa-addins-store';
import { isPersistedAddinsInitialized } from 'owa-addins-persistent';
import { isPersistentTaskpaneEnabled } from 'owa-addins-feature-flags';
import { SelectionType } from './SelectionType';
import {
    doesItemSupportAddins,
    isEventDuplicate,
    isInlineComposeOpen,
    isItemPartSelected,
    isModeChanged,
} from './NavigationConditions';

export default function onItemNavigation(selectionType: SelectionType, hostItemIndex?: string) {
    if (!isPersistentTaskpaneEnabled()) {
        return;
    }

    switch (selectionType) {
        case SelectionType.NotSupported:
            terminateAddinNavigationOperation();
            break;

        case SelectionType.Empty:
            sendErrorToAddinNavigationOperation(TaskPaneErrorType.Empty);
            break;

        case SelectionType.Multi:
            sendErrorToAddinNavigationOperation(TaskPaneErrorType.Multi);
            break;

        case SelectionType.Single:
            hostItemIndex && handleSingleSelectionType(selectionType, hostItemIndex);
            break;
    }
}

function handleSingleSelectionType(selectionType: SelectionType, hostItemIndex: string) {
    if (
        !doesItemExist(hostItemIndex) ||
        !isExtensibilityContextInitialized() ||
        !isPersistedAddinsInitialized() ||
        isInlineComposeOpen(hostItemIndex) ||
        !isItemPartSelected(hostItemIndex) ||
        isEventDuplicate(hostItemIndex)
    ) {
        ignoreNavigationOperation();
    } else if (!doesItemSupportAddins(hostItemIndex)) {
        sendErrorToAddinNavigationOperation(TaskPaneErrorType.NotSupported);
    } else if (isModeChanged(hostItemIndex)) {
        reOpenAddinNavigationOperation(hostItemIndex);
    } else {
        sendItemUpdateToAddinNavigationOperation(hostItemIndex);
    }
}
